<template>
  <div class="notice">
    <ul>
      <li v-for="(item,a) in Data" :key="a">
        <a href @click="todigest($event,item.ArticleID,item.Title)"><img src="../../../assets/images/arrow.gif" />{{item.Title}}</a>
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Data: []
    };
  },
  props: ["params"],
  mounted() {
    this.$store
      .dispatch("_getXZPH", this.params)
      .then(res => {
        this.Data = res.data.Data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods:{
    todigest(e, id, title,type) {
      let path=''
      
     path="/digest?ArticleID=" + id
      
      e.preventDefault();
      let routeUrl = this.$router.resolve({
        path: path
      });
      window.open(routeUrl.href, "_blank");
    },
   
  }
};
</script>